import Vue from 'vue'
import Router from 'vue-router'
import appRouter from './router'; //pc端路由
import phoneRouter from './phone'; //移动端路由
import Cookies from 'js-cookie';

Vue.use(Router)

// 路由配置
const RouterConfig = {
  mode: 'history',
  routes: appRouter
};


if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
  RouterConfig.routes = phoneRouter
}

const vuerouter = new Router(RouterConfig);

//路由的全局前置守卫 to:即将要进去的路由目标 from 当前到离开的路由目标
vuerouter.beforeEach((to, from, next) => {
  // console.log(to)
  if(to.name == 'vipApply' || to.name == 'Review') {
    next({ name: 'home' })
  }else{
    next()
  }
  // console.log('from',from)
  // console.log('to',to)
  //进行管道中的下一个钩子 next(false):中断当前的导航
         //next({ path: '/' })跳到一个不同的地址
})
//路由的全局后置钩子
vuerouter.afterEach((to, from) => {
  // ...
  window.scrollTo(0, 0);
})

export default vuerouter;




// WEBPACK FOOTER //
// ./src/router/index.js